<template>
  <div class="home-news">
    <div class="news">
      <div class="title">华院新闻</div>
      <div class="content">
        <div class="news-item" v-for="(item, index) in news" :key="`news-item${index + 1}`" @click="getDetail(item)">
          <div class="news-item-title">{{item.title}}</div>
          <div class="news-item-time">{{item.create_time}}</div>
        </div>
      </div>
      <div class="view-more" @click="goNews">查看更多></div>
    </div>
    <img :src="step" alt="step" class="step">
    <Footer class="about"/>
  </div>
</template>
<script>
import Footer from "@/components/footer.vue"
import step from '@/../static/img/home/step.png'
import { formatCreateTime } from '@/utils/dateFormat'
export default {
  components: {Footer},
  data() {
    return {
      step,
      news: []
    }
  },
  mounted() {
    this.getNews();
  },
  methods: {
    getNews() {
      let postdata = {
        type: "news",
        page: 1,
        pagesize: 6
      };
      this.axios
        .post(this.$rootUrl + "/unidt/query_article_page", postdata)
        .then(res => {
          const { code, data } = res.data;
          if (code == 0) {
            this.news = data.map(item => formatCreateTime({ ...item }))
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getDetail(item) {
      if (!item || item.content === false) return
      this.$router.push({
        path: '/news/' + item.id
      })
    },
    goNews() {
      this.$router.push('/news')
    }
  }
}
</script>
<style lang="less" scoped>
.home-news {
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .news {
    margin-top: 170px;
    width: 100%;
    flex: 1;
    .title {
      font-size: 44px;
      line-height: 60px;
      text-align: center;
    }
    .content {
      width: 100%;
      .news-item {
        width: calc(~'100% - 128px');
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 24px auto;
        .news-item-title {
          width: 75%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 24px;
          line-height: 52px;
          font-weight: 500;
          color: #08204D;
        }
        .news-item-time {
          font-size: 24px;
          font-weight: 400;
          color: #08204D;
          line-height: 52px;
          font-weight: 500;
        }
      }
    }
    .view-more {
      text-align: center;
      margin-top: 24px;
      font-size: 24px;
      font-weight: 500;
      color: #08204D;
      cursor: pointer;
    }
  }
  .step {
    width: 750px;
    height: 668px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/home_news.vue